export default __webpack_public_path__ + "static/media/resume.579fdf65.pdf";